import { create } from 'zustand';

interface FeedbackState {
  open: boolean;
  initialText: string;
  openModal: (initialText?: string) => void;
  closeModal: () => void;
}

export const useFeedbackStore = create<FeedbackState>((set) => ({
  open: false,
  initialText: '',
  openModal: (initialText = '') => set({ open: true, initialText }),
  closeModal: () => set({ open: false, initialText: '' }),
}));
